import { Select } from '@/components/ui/select'
import { cn } from '@/lib/utils'

export interface PeriodOption {
  value: string
  label: string
}

/**
 * The small period dropdown that sits in each card header in the design
 * ("This Month", "Last 6 Months", "May 2025").
 *
 * It was a native `<select>` with a chevron overlaid on top; the overlay was pinned with a
 * class Tailwind does not generate, so the arrow rendered on the wrong side of the field.
 * The shared `Select` lays its chevron out as a flex sibling instead, which puts it on the
 * trailing edge in both directions with nothing to position.
 */
export function PeriodSelect({
  value,
  options,
  onChange,
  label,
  className,
}: {
  value: string
  options: PeriodOption[]
  onChange: (value: string) => void
  label: string
  className?: string
}) {
  return (
    <Select
      value={value}
      aria-label={label}
      onChange={(event) => onChange(event.target.value)}
      className={cn('h-8 w-auto gap-1.5 px-2.5 text-xs font-medium', className)}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  )
}
